///add a script so chat widget wont show untill after 500 px of scrolling

const GORGIAS_OPEN_CL = "gorgias-widget-opened"

function handleChatWidget(){
    const scroll = window.scrollY;
    const scroll_threshold = 500

    // The PDP sticky add-to-bag bar overlaps the launcher; while the bar
    // is visible (body class set by <pdp-sticky-atc> in product-v2.js)
    // keep the launcher hidden — unless the chat window itself is open.
    const suppressed = document.body.classList.contains("pdp-sticky-atc-visible");

    if(document.body.classList.contains(GORGIAS_OPEN_CL) || (scroll > scroll_threshold && !suppressed)){
        theme.ChatWidget.show();
    }else {
        theme.ChatWidget.hide();
    }
}

document.addEventListener('DOMContentLoaded', function() {
    
   window.addEventListener('scroll', throttle(handleChatWidget, 100), {passive: true})

    var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

    initGorgiasChatPromise.then(async () => {
        // custom code
        console.log('Gorgias init');

        GorgiasChat.on('widget:opened', function () {
            document.body.classList.add(GORGIAS_OPEN_CL)
            handleChatWidget();
        });

        GorgiasChat.on('widget:closed', function () {
            document.body.classList.remove(GORGIAS_OPEN_CL)
            // Re-arbitrate right away — otherwise the launcher keeps its
            // last commanded state (e.g. shown over the PDP sticky bar)
            // until the next scroll event.
            handleChatWidget();
        });


        handleChatWidget();
    })

    var initGorgiasBridgePromise = (window.GorgiasBridge) 
            ? window.GorgiasBridge.init() 
            : new Promise(function (resolve) {
                    const timer = setTimeout(() => reject(), 500);
                    window.addEventListener('gorgias-bridge-loaded', function () {
                            clearTimeout(timer);
                            resolve();
                    })
            });

    initGorgiasBridgePromise.then(async () => {
        // Cart updates subscription will happen here

        console.log('Gorgias - Bridge Loaded');

        window.GorgiasBridge.subscribeToCartUpdated(function() {
        // Your custom code goes here
            console.log('Gorgias - Cart has been updated!')
            if(theme.Drawer){
                theme.Drawer.cartReloadPageRefresh();
            }
            
        })
    })
});



